import axios from "axios";
import { useMutation } from "@tanstack/react-query";
import { API_BASE_RELATIVE_PATH, API_BASE_PATH } from "../Config/Config";

const executeTestSuites = async ({
  prodid,
  suitid,
  envname,
  envUrl,
  browser,
  stop,
  rerun,
  runparallel,
  rerunparallel,
  ssfail,
  indEmail,
  inputemail,
  height,
  width,
  tsrId,
  iterations,
  proxy,
  statustype,
  variables,
  inttype,
  intid,
  issueobj,

  execLogType,
  execLogLevel,

  issueLogType,
  issueLogLevel,
  issueMessage,
  issueDescription,
}) => {
  const userDetails = localStorage.getItem("userDetail");
  if (!userDetails) throw new Error("No user details found in localStorage");
  const user = JSON.parse(userDetails);

  let url =
    `${API_BASE_PATH}${API_BASE_RELATIVE_PATH}` +
    `?action=ExecuteTestSuites` +
    `&companyid=${user.companyid}` +
    `&prodid=${prodid}` +
    `&SuiteId=${suitid}` +
    `&envName=${envname || ""}` +
    `&envUrl=${envUrl || ""}` +
    `&browsername=${browser}` +
    `&height=${height || ""}` +
    `&width=${width || ""}` +
    `&RerunFailTest=${rerun}` +
    `&StopTestAfterFailure=${stop}` +
    `&RunsTestsinParallel=${runparallel}` +
    `&resultsemail=${inputemail || ""}` +
    `&criteria=${statustype || ""}` +
    `&tsrid=${tsrId || ""}` +
    `&ssonerror=${ssfail}` +
    `&iterations=${iterations}` +
    `&proxy=${proxy || ""}` +
    `&indEmail=${indEmail}` +
    `&rerunparallel=${rerunparallel || false}` +
    `&inttype=${inttype}` +
    `&intid=${intid}` +
    `&logId=${issueobj?.logId || ""}` +
    `&projectkey=${issueobj?.projectkey || ""}` +
    `&execLogType=${execLogType}` +
    `&execLogLevel=${execLogLevel}` +
    `&issueLogType=${issueLogType || ""}` +
    `&issueLogLevel=${issueLogLevel || ""}` +
    `&issueMessage=${issueMessage || ""}` +
    `&issueDescription=${issueDescription || ""}`;

  const requestBody = variables ? JSON.parse(variables) : {};

  const response = await axios.post(url, requestBody);
  return response.data;
};

const useExecuteTestSuitesMutation = (options) => {
  return useMutation({
    mutationFn: executeTestSuites,
    ...options,
  });
};

export default useExecuteTestSuitesMutation;
